import React from "react";

// Style \\
import "../../assets/styles/sections/productsHero.scss";

const ProductsHero = () => {
  return (
    <section className="productHero">
      <div className="productHero_bg">
        <div className="containers">
          <div className="productHero_items">
            <div className="productHero_items_title">
              <p>Home / Products</p>
              <h2>Products</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsHero;
